export enum Environments {
  Production = 'production',
  Beta = 'beta',
  Development = 'development',
  Local = 'local',
}

export const isEnvironment = (environment: Environments) =>
  import.meta.env.VITE_ENVIRONMENT === environment;

export const isProductionEnvironment =
  import.meta.env.VITE_ENVIRONMENT === Environments.Production;

export const isBetaEnvironment =
  import.meta.env.VITE_ENVIRONMENT === Environments.Beta;

export const isDevelopmentEnvironment =
  import.meta.env.VITE_ENVIRONMENT === Environments.Development;

export const isLocalEnvironment =
  import.meta.env.VITE_ENVIRONMENT === Environments.Local;
